
import { registerSchemas } from './register';
// ---------------------------------------------------------------------- //

export const YupSchemas = {
  register: registerSchemas
};